














import CommonBase from "../CommonBase";
import {NativeApi} from "@/modules/NativeBridge";
import {Component, Inject} from "vue-property-decorator";
import {isIosWebview} from "../../modules/utils";

@Component
export default class IosWebviewButNotAppWarning extends CommonBase {
    @Inject()
    nativeApi!: NativeApi;

    get iosWebviewButNotApp() {
        return isIosWebview() && !this.nativeApi.available;
    }
}
